// src/api/developer.ts

import api from '@/lib/axios';
import type { Developer } from '@/types/developer';
import type {
  UpdatePasswordRequest,
  UpdateProfileRequest,
  SendDeleteAccountCodeResponse,
  DeleteAccountRequest,
  DeleteAccountResponse,
} from '@/types/auth';

/**
 * 获取当前开发者信息
 * GET /v1/developer/profile
 */
export const getCurrentDeveloper = async (): Promise<Developer> => {
  return api.get('/developer/profile');
};

/**
 * 修改密码
 * PUT /v1/developer/password
 */
export const updatePassword = (
  data: UpdatePasswordRequest
): Promise<void> => {
  return api.put('/developer/password', data);
};

/**
 * 更新个人信息
 * PUT /v1/developer/profile
 */
export const updateProfile = (
  data: UpdateProfileRequest
): Promise<void> => {
  return api.put('/developer/profile', data);
};

/**
 * 开发者登出
 * POST /v1/developer/logout
 */
export const logout = (): Promise<void> => {
  return api.post('/developer/logout');
};

/**
 * 只更新开发者用户名
 * PATCH /v1/developer/profile/name
 */
export const updateProfileName = (name: string): Promise<void> => {
  return api.patch('/developer/profile/name', { name });
};

/**
 * 发送注销账号验证码
 * POST /v1/developer/send-delete-code
 */
export const sendDeleteAccountCode = (): Promise<SendDeleteAccountCodeResponse> => {
  return api.post('/developer/send-delete-code', {});
};

/**
 * 注销开发者账号
 * POST /v1/developer/delete-account
 */
export const deleteAccount = (
  data: DeleteAccountRequest
): Promise<DeleteAccountResponse> => {
  return api.post('/developer/delete-account', data);
};